export default "__VITE_ASSET__iyL_WUhd__"